import { Account, AccountType } from '@mews-commander/data-access';
import { DividedList } from './DividedList';
import { AccountClassifications } from './AccountClassifications';

interface CompanionClassificationsListProps {
    accounts: Record<string, Account>;
    companionIds: string[];
    handleClassificationsClick: (event: React.MouseEvent<HTMLAnchorElement>, account: Account) => void;
}

export const CompanionClassificationsList = ({
    accounts,
    companionIds,
    handleClassificationsClick,
}: CompanionClassificationsListProps) => (
    <DividedList
        collectionIds={companionIds}
        renderItem={(id) => {
            const account = accounts?.[id];

            if (!account || account.data.discriminator !== AccountType.Customer) return null;

            return (
                <AccountClassifications
                    classifications={account.data.value.classifications}
                    onClick={(e) => handleClassificationsClick(e, account)}
                />
            );
        }}
    />
);
